import React from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { useLang } from "@/lib/i18n";
import { resolveImg, onImgError } from "@/lib/images";
import LangSwitcher from "@/components/LangSwitcher";

const LOGO_SRC = "/api/files/melograno/properties/0fb53515-1026-4c3f-b743-74a64b9e47f3.jpg";

export default function PublicHeader() {
  const [open, setOpen] = React.useState(false);
  const { t } = useLang();
  const links = [
    { to: "/", label: t.nav.home },
    { to: "/proprieta", label: t.nav.properties },
    { to: "/storia", label: t.nav.story },
    { to: "/contatti", label: t.nav.contact },
  ];

  return (
    <header className="glass-header sticky top-0 z-40" data-testid="public-header">
      <div className="mel-container flex items-center justify-between py-3 md:py-5 gap-3">
        <Link to="/" className="flex items-center gap-2 md:gap-3 min-w-0" data-testid="brand-link">
          <img
            src={resolveImg(LOGO_SRC)}
            onError={onImgError}
            alt="The apARTments"
            className="h-8 md:h-10 w-auto rounded-sm flex-shrink-0"
          />
          <div className="leading-tight min-w-0">
            <div className="font-serif text-base md:text-lg tracking-tight truncate">Il Melograno</div>
            <div className="eyebrow truncate" style={{ fontSize: '0.6rem' }}>apARTments</div>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-6 lg:gap-10">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              data-testid={`nav-${l.to.replace('/', '') || 'home'}`}
              className={({ isActive }) =>
                `text-sm font-medium transition-colors whitespace-nowrap ${isActive ? 'text-[var(--mel-primary)]' : 'text-[var(--mel-text)] hover:text-[var(--mel-primary)]'}`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-2 lg:gap-3">
          <LangSwitcher />
        </div>

        <div className="flex lg:hidden items-center gap-2 flex-shrink-0">
          <LangSwitcher compact />
          <button
            className="p-2 -mr-2"
            onClick={() => setOpen(!open)}
            aria-label="menu"
            data-testid="mobile-menu-toggle"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-[var(--mel-border)] bg-[var(--mel-bg)]" data-testid="mobile-menu">
          <div className="mel-container py-3 flex flex-col gap-1">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `text-sm py-2.5 border-b border-[var(--mel-border)] last:border-none ${isActive ? 'text-[var(--mel-primary)] font-medium' : ''}`
                }
                data-testid={`mnav-${l.to.replace('/', '') || 'home'}`}
              >
                {l.label}
              </NavLink>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}
